import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoggerService } from '@shared/modules/logger/service/logger.service';
import { map, tap } from 'rxjs';

import { LogActions, LogError, LogInfo } from '../../actions';

@Injectable()
export class LoggerEffects {
  constructor(
    private actions$: Actions,
    private loggerService: LoggerService,
  ) {}

  logInfo$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LogInfo),
        map((action) => action.payload),
        tap((payload) => {
          const info = { ...payload };
          delete info['code'];
          return this.loggerService.info(info, payload.code);
        }),
      ),
    { dispatch: false },
  );

  logError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LogError),
        map((action) => action.payload),
        tap((payload) => {
          const error = { ...payload };
          delete error['code'];
          return this.loggerService.error(error, payload.code);
        }),
      ),
    { dispatch: false },
  );

  logActions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LogActions),
        tap(() =>
          this.loggerService.info(
            { message: 'Action Stream', actions: this.loggerService.dispatchedActions },
            123,
          ),
        ),
      ),
    { dispatch: false },
  );
}
